var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gobierto-text-editable" },
    [
      _c(
        _vm.tag,
        {
          tag: "component",
          attrs: { contenteditable: "" },
          on: {
            input: _vm.handleInput,
            focus: _vm.handleFocus,
            keypress: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.handleEnterKey($event)
            }
          }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.icon ? _c("i", { staticClass: "fas fa-edit" }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }